import * as React from "react";

export const HorizontalLine = () => {
    return <hr />;
};
